import { getUserInfo } from 'Utils/Helpers'

export * from './startPolling'

const regexPattern = /^[a-zA-Z0-9_= :.@*!~+-]*$/

/**
 * Function to create a data test id, for html elements
 *
 * Eg:
 *
 * NOTE: This function is present in the uxpkg project also. Hence, any changes here might need to be reflected into
 * the uxpkg project.
 *
 * getHTMLDataTestID('application', 'button', 'create') => "application-button-create-default"
 * getHTMLDataTestID('application', 'input', 'app-name') => "application-input-app-name-default"
 *
 * @param {string} feature Feature where the element is used like, users, groups, applications, etc.
 * @param {keyof JSX.IntrinsicElements} type The type of HTML Element
 * @param {string} name The noun/verb describing the element.
 * @param {string} uid Unique id for element
 * @returns {string}
 */
export const getHTMLDataTestID = (feature, type, name, uid = 'default') => {
  return `${feature}-${type}-${name}-${uid}`
}

export const isValidObjectName = (name) => regexPattern.test(name)

export const getAppEnvironment = () => {
  const user = getUserInfo()
  if (user && user.controller) {
    if (user.controller.includes('privilege.test')) return 'test'
    else if (user.controller.includes('privilege.ort')) return 'ort'
    else if (user.controller.includes('privilege.pingone.com.au')) return 'au'
    else if (user.controller.includes('privilege.pingone.sg')) return 'sg'
    else if (user.controller.includes('privilege.pingone.eu')) return 'eu'
    else if (user.controller.includes('privilege.pingone.ca')) return 'ca'
    else return 'prod'
  }
  return 'test'
}

export const downloadFile = (data, fileName) => {
  // 1. Generate the dynamic content
  const dynamicContent = data

  // 2. Create a Blob from the content
  // 'text/plain' specifies the file type
  const blob = new Blob([dynamicContent], { type: 'text/plain' })

  // 3. Create an Object URL for the Blob
  const url = URL.createObjectURL(blob)

  // 4. Create a temporary 'a' element for the download
  const link = document.createElement('a')
  link.href = url
  // Set the file name for the download
  link.download = fileName

  // Optional: Make the link invisible before clicking
  link.style.display = 'none'
  document.body.appendChild(link)

  // 5. Simulate a click to trigger the download
  link.click()

  // 6. Clean up the temporary resources
  document.body.removeChild(link)
  URL.revokeObjectURL(url) // Free up memory by revoking the Object URL
}

export const downloadBinaryFile = (data, fileName) => {
  const blob = new Blob([data], { type: 'application/octet-stream' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
